export enum ItemType {
  FOLDER = 'folder',
  DOCUMENT = 'document',
}
